import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const PayloadParserView = loadable(() => import('../components/PayloadParser/PayloadParserView')).default;
export const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('Emulation own props', ownProps);
    return {};
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('EmulatorContainer Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PayloadParserView);
